import { Box } from "@nulogy/components";
import styled from "styled-components";

const WorkBlockPreviewBox = styled(Box)(({ theme }) => ({
  ".blockMenu": {
    backgroundColor: `${theme.colors.lightBlue} !important`,
  },

  ".workBlockIcon": {
    fill: `${theme.colors.blackBlue} !important`,
  },

  "*": {
    color: `${theme.colors.blackBlue} !important`, // The !important is required to ensure text color in the block is correct
  },

  "&:after": {
    borderColor: `${theme.colors.blackBlue} !important`,
  },

  "&:before": {
    borderColor: `${theme.colors.blackBlue} !important`,
  },
  backgroundColor: `${theme.colors.lightBlue} !important`,
  border: `1px solid ${theme.colors.blackBlue} !important`,
  borderRadius: `${theme.radii.medium} !important`,
}));

export default WorkBlockPreviewBox;
